// extracted by mini-css-extract-plugin
export default {"form":"FormHeader_form__41HyM","form__button-icon":"FormHeader_form__button-icon__u4L15"};